module.exports = __webpack_public_path__ + "static/other/face_painting.e7d96231.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/face_painting.json
// module id = 2659
// module chunks = 0